import { Component, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ApplicationType } from 'src/api/models/application-type';
import { AzureAuthService } from 'src/service/azure-auth.service';
import { ApplicationConfigService } from 'src/service/application-config.service';
import { ApplicationService,CustomerService } from 'src/api/services';


@Component({
  selector: 'app-room-air-quality-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class RoomAirQualityHomeComponent implements OnInit {

  public applications : ApplicationType[];
  
  constructor(
    private service: ApplicationService,
    private app: ApplicationConfigService,
    public azureAuthService: AzureAuthService,
    public customerService: CustomerService,
    private toasterService: ToastrService) { 
    
  }

  ngOnInit(): void {    
    if (this.azureAuthService.isAdmin()){
      if (this.app.customers == null){
        this.customerService.CustomerGetAllCustomers().subscribe(c => { 
          this.app.customers = c;
        });
      }
    } 
    if (this.app.customerId == null) {
      this.app.customerId = this.azureAuthService.userProfile.customerId;
    }
  }

}
